import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
  glow?: 'income' | 'expense' | 'none';
}

export function Card({
  children,
  className = '',
  title,
  action,
  glow = 'none',
}: CardProps) {
  const glowClass =
    glow === 'income'
      ? 'stat-glow-income'
      : glow === 'expense'
        ? 'stat-glow-expense'
        : '';

  return (
    <div
      className={`glass-card shadow-sm ${glowClass} ${className}`}
    >
      {(title || action) && (
        <div className="flex items-center justify-between border-b border-dark-border px-5 py-4">
          {title && <h3 className="font-semibold text-gray-100">{title}</h3>}
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}
